var _rect, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiplomaTemplate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 204,
    viewBox: "0 0 302 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 302,
    height: 204,
    rx: 16,
    fill: "#EBF2FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2025_23584)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 156,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EBF2FE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.869 67.9986C154.185 65.3338 147.815 65.3338 142.131 67.9986L115.366 80.5464C111.062 82.5642 109.94 88.2541 112 92.1866L112 112C112 113.657 113.343 115 115 115C116.657 115 118 113.657 118 112V96.6881L142.131 108.001C147.815 110.666 154.185 110.666 159.869 108.001L186.634 95.4536C192.455 92.7242 192.455 83.276 186.634 80.5466L159.869 67.9986Z",
    fill: "#B1CDFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123 105.659V120.502C123 124.534 125.014 128.309 128.541 130.262C134.415 133.515 143.816 138 151 138C158.184 138 167.585 133.515 173.459 130.262C176.986 128.309 179 124.534 179 120.502V105.659L162.416 113.434C155.118 116.855 146.882 116.855 139.584 113.434L123 105.659Z",
    fill: "#B1CDFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2025_23584",
    x: 249,
    y: 151,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2025_23584"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2025_23584",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiplomaTemplate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/diploma_template.ffcfd705bec94ec282209d4639d26da1.svg";